import { sifeEndpoints } from './sifeEndpoints';

export const endpointHandler = () => {
  return {
    ...sifeEndpoints,
  };
};
